import { useCallback, useEffect, useRef, useState } from "react";
import {
  buildNoticeOneTapCopyText,
  buildNoticeOneTapXText,
  openXIntentCompose,
  type NoticeShareFields,
} from "../lib/notice-share-snippet";

export function NoticeShareRow({ fields }: { fields: NoticeShareFields }) {
  const [copied, setCopied] = useState(false);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, []);

  const flashCopied = useCallback(() => {
    setCopied(true);
    if (hideTimer.current) clearTimeout(hideTimer.current);
    hideTimer.current = setTimeout(() => setCopied(false), 2200);
  }, []);

  const copy = async () => {
    const text = buildNoticeOneTapCopyText(fields);
    try {
      await navigator.clipboard.writeText(text);
      flashCopied();
    } catch {
      try {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.left = "-9999px";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        flashCopied();
      } catch {
        /* ignore */
      }
    }
  };

  return (
    <div className="home-notice-share">
      <div className="row home-notice-share-actions">
        <button className="btn secondary home-notice-share-btn" type="button" onClick={() => void copy()}>
          コピペ
        </button>
        <button className="btn secondary home-notice-share-btn" type="button" onClick={() => openXIntentCompose(buildNoticeOneTapXText(fields))}>
          X下書き
        </button>
        {fields.linkUrl ? (
          <a className="btn secondary home-notice-share-btn home-notice-link-btn" href={fields.linkUrl} target="_blank" rel="noreferrer">
            🔗
          </a>
        ) : null}
      </div>
      {copied ? (
        <p className="home-notice-share-toast" role="status" aria-live="polite">
          コピーしました
        </p>
      ) : null}
    </div>
  );
}
